export default [
  {
    header: "Dashboards",
    icon: "HomeIcon",
  },
]
